// @ts-nocheck
import { getTimeDiff } from '../../utils'

export interface timeObject {
    hours: number
    minutes: number
    seconds: number
    totalMilli: number
}

export const getTotalTime = (d1: Date, d2: Date, a?: timeObject): timeObject => {
    let milli = getTimeDiff(d1, d2) + (a ? a.totalMilli : 0)
    let seconds = Math.floor(milli / 1000)
    let minutes = Math.floor(seconds / 60)
    seconds -= minutes * 60
    let hours = Math.floor(minutes / 60)
    minutes -= hours * 60
    return { hours, minutes, seconds, totalMilli: milli }
}

export const parentClassInTarget = (target: Element, className: string) => {
    let currentTarget = target
    while (currentTarget) {
        if (currentTarget.classList.contains(className)) return true
        currentTarget = currentTarget.parentElement
    }
    return false
}
